<template>
  <div class="loader">
    <Transition name="fade">
      <img
        v-if="Render"
        src="@/assets/Images/Global/Loader.gif"
        alt=""
        class="loader__item"
      />
    </Transition>
  </div>
</template>

<script>
export default {
  name: "Loader",
  data() {
    return {
      Render: false,
    };
  },
  mounted() {
    this.$root.$on("Loader", () => {
      this.Render = true;
    });
  },
};
</script>

<style lang="scss" scoped>
.loader {
  width: 100dvw;
  height: 100dvh;
  overflow: hidden !important;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  &__item {
    overflow: hidden !important;
    clip-path: inset(3px 3px);
    height: 125px;
  }
}
</style>
